import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UserService } from '../service/user.service';
import { Overlay } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { Log } from '../util/log';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NewUserRequest } from '../model/newUserRequest';
import { ViewRequestDialogComponent } from '../view-request-dialog/view-request-dialog.component';
import { AppComponent } from '../app.component';
import { AliasOwnerRel } from '../model/AliasOwnerRel';
import { InsertuserdialogComponent } from '../insertuserdialog/insertuserdialog.component';
import { Router } from '@angular/router';


@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.css']
})
export class RequestsComponent implements OnInit {


  @ViewChild('requeststable', { static: true }) table;
  @ViewChild('requestsloader', { static: true }) loader;
  @ViewChild(MatSort) sort: MatSort;

  lastPickedFilter: any = 1;

  tableRequestsList = new MatTableDataSource<NewUserRequest>([]);

  requestsList: NewUserRequest[] = [];


  pendingRequestsList: NewUserRequest[] = [];
  acceptedRequestsList: NewUserRequest[] = [];
  rejectedRequestsList: NewUserRequest[] = [];

  pickedFilterType: any = 1;;

  isUserAlias: boolean;
  aliasesMap = new Map();

  canUserUserEdit: boolean = false;
  canUserManageRequestTypes: boolean = false;


  displayedColumns: string[] = [
    'date',
    'firstname',
    'lastname',
    'email',
    'notes',
    // 'acceptRejectNotes',   <-------- diventa troppo denso, troppe info
    'state',
    'viewRequest'
  ];

  constructor(
    public appComponent: AppComponent,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private overlay: Overlay,
    private router: Router

  ) { }

  ngOnInit(): void {
  }


  ngAfterViewInit() {
    this.loader.showLoading();

    this.amIAlias();
    setTimeout(() => {
      this.getNewUserRequests();
    }, 1000);

  }

  async amIAlias() {

    const isAlias = await this.appComponent.isAlias();
    if (isAlias) {

      Log.debug("\n\n\n\n\t  USER IS ALIAS \n\n\n\n");

      this.isUserAlias = true;

      this.canUserUserEdit = await this.checkAliasPermissions("insert-requests");
      this.canUserManageRequestTypes = await this.checkAliasPermissions("ManageRequestTypes");

    } else {
      Log.debug("\n\n\n\n\t USER NOT ALIAS \n\n\n\n");
      this.isUserAlias = false;
      this.canUserUserEdit = true;
      this.canUserManageRequestTypes = true;
      //se sono un owner faccio una get degli alias per avere i loro dati --> Le newUserRequests contengono solamente l'uid dell'alias
      this.getOwnerAliases();
    }

  }

  async checkAliasPermissions(feature: string): Promise<boolean> {
    return this.userService.checkAliasPermissions(feature);
  }


  setRequestsFilter(picked: any) {
    // 2 = pending
    // 3 = accepted
    // 4 = rejected

    this.lastPickedFilter = picked;

    this.pickedFilterType = picked.value;

    this.loader.showLoading();

    if (picked.value == "1") {
      this.tableRequestsList.data = this.requestsList;
    } else if (picked.value == "2") {

      let filteredRequests: NewUserRequest[] = [];

      this.requestsList.forEach(request => {
        if (!request.rejected && !request.accepted) {
          filteredRequests.push(request)
        }
      });
      this.tableRequestsList.data = filteredRequests

    } else if (picked.value == "3") {

      let filteredRequests: NewUserRequest[] = [];

      this.requestsList.forEach(request => {
        if (request.accepted) {
          filteredRequests.push(request)
        }
      });
      this.tableRequestsList.data = filteredRequests


    } else if (picked.value == "4") {

      let filteredRequests: NewUserRequest[] = [];

      this.requestsList.forEach(request => {
        if (request.rejected) {
          filteredRequests.push(request)
        }
      });
      this.tableRequestsList.data = filteredRequests

    }

    this.cdRef.detectChanges();

    setTimeout(() => {
      this.loader.hideLoading();
    }, 250);
  }

  onKey(event: any) {

    let filterString = event.target.value;

    this.table.dataSource.filter = filterString.trim().toLowerCase();
  }


  filterTable(data: NewUserRequest, filter: string): boolean {

    if (data && data.firstname && data.firstname.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data && data.lastname && data.lastname.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data && data.email && data.email.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data && data.notes && data.notes.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data && data.state && data.state.toLowerCase().indexOf(filter) != -1) {
      return true;
    }

    return false;
  }


  getNewUserRequests() {

    this.userService.getNewUserRequests(this.userService.meUser.uid).subscribe((data) => {

      Log.debug("\n\n\n data ");
      Log.debug(data);

      //metto in ordine
      data.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());

      this.requestsList = data;

      if (!this.isUserAlias) {

        Log.debug("\n\n\t getNewUserRequests NOT ALIAS");

        this.requestsList.forEach(request => {
          request.alias = this.aliasesMap.get(request.aliasUid)
        });

      } else {

        Log.debug("\n\n\t getNewUserRequests IS ALIAS");


        this.requestsList.forEach(request => {
          request.alias = this.userService.meAliasUser;
        });
      }

      this.tableRequestsList.sortingDataAccessor = (item, property) => {
        if (property === 'date') {
          // Ensure item.createdAt is a Date
          return item.createdAt ? item.createdAt.getTime() : 0;
        }

        // Read the value safely
        const value = item ? (item as any)[property] : null;

        // Normalize strings to lowercase so sorting is case-insensitive
        if (value == null) {
          return '';
        }
        if (typeof value === 'string') {
          return value.toLowerCase();
        }

        return value;
      };

      this.tableRequestsList.data = this.requestsList;
      // Use the MatTableDataSource instance for filter/sort instead of accessing table.dataSource
      this.tableRequestsList.filterPredicate = this.filterTable;
      this.tableRequestsList.sort = this.sort;

      this.loader.hideLoading();


    }, error => {

      Log.debug(error);

      this.loader.showError();
    });
  }

  getOwnerAliases() {
    this.userService.getOwnerAliases(this.userService.meUser.uid).subscribe(data => {

      data.forEach(element => {
        this.aliasesMap.set(element.alias.uid, element)
      });

      Log.debug("\n\n\n\tthis.aliasesMap");
      Log.debug(this.aliasesMap);

    }, error => {
      Log.debug(error);

      this.loader.hideLoading();
      this.loader.showError();
    });
  }

  onRowClicked(row: NewUserRequest) {

    Log.debug('clicked user with id ' + row.id);

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ViewRequestDialogComponent, {
      width: '800px',
      data: { data: row, isUserAlias: this.isUserAlias },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {

      Log.debug("\n\n Close dialog response");
      Log.debug(response);


      if (response === undefined || response == false) {
        // La richiesta non è stata approvata

        Log.debug("do nothing");

        return

      } else if (response == "Deleted") {

        Log.debug("To delete");

        const index = this.requestsList.findIndex(r => r.id === row.id);
        Log.debug("index");

        Log.debug(this.requestsList);

        if (index > -1) {
          this.requestsList.splice(index, 1);
          this.tableRequestsList.data = this.requestsList;
          this.setRequestsFilter(this.lastPickedFilter);
          this.cdRef.detectChanges();
        }
        Log.debug(this.requestsList);

      } else {
        row.accepted = response.accepted;
        row.rejected = response.rejected;
        row.acceptRejectNotes = response.acceptRejectNotes;
        row.approvedBy = response.approvedBy;
        row.startDate = response.startDate;
        row.expirationDate = response.expirationDate;

        row.updateState();

        Log.debug(row);
        Log.debug(this.requestsList);

        this.setRequestsFilter(this.lastPickedFilter);

        this.cdRef.detectChanges();
      }
    });

    this.cdRef.detectChanges();
  }

  addUser() {
    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    let lang = this.appComponent.getCurrentLanguage().toLowerCase();


    const dialogRef = this.dialog.open(InsertuserdialogComponent, {
      width: '1000px',
      data: { language: lang },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {

      Log.debug("\n\n Close dialog response");
      Log.debug(response);

      if (response === undefined || response == false) {

      }
    });

    this.cdRef.detectChanges();

  }

  openRequestTypes() {
    this.router.navigate(['request-types']);
  }

}
